import React, {Component} from 'react';
import   Autosuggest  from "react-autosuggest";
import FormGroupSelectInput from "./formGroupSelectInput";
import Button from "./button";
import CustomSelect from "./General/customSelect";
import { LEGAL_ADVICE_TEXT } from '../helpers/variables';

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion!== undefined?suggestion.forename + ' ' + suggestion.surname:null;

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => (
  <div>
		{suggestion.forename}{' '}{suggestion.surname}
  </div>
);

class AgentsListFilters extends Component {
	constructor(props) {
		super(props);
	}

	// Teach Autosuggest how to calculate suggestions for any given input value.
	getSuggestions = value => {
		return this.props.User.solicitorUsersListSettings.suggestions;

	};


	onChange = (event, {newValue, method}) => {
		if (typeof newValue !== 'undefined') {
			if (newValue === "") {
				this.props.SolicitorDisplaySetting('suggestions', this.props.User.allSolicitorUsers);
			}
			this.props.SolicitorDisplaySetting('value', newValue)
		}
	};

	// Autosuggest will call this function every time you need to update suggestions.
	// You already implemented this logic above, so just use it.
	onSuggestionsFetchRequested = ({value, reason}) => {
		this.props.SolicitorDisplaySetting('suggestions', this.getSuggestions(value))
	};

	// Autosuggest will call this function every time you need to clear suggestions.
	onSuggestionsClearRequested = () => {
		if (this.props.User.solicitorUsersListSettings.value === "")
			this.props.UpdateSolicitorsDisplayedUsers(this.props.User.allSolicitorUsers);

	};

	onAgentSuggestionSelected = (event, {suggestion, suggestionValue, suggestionIndex, sectionIndex, method}) => {
	    if(!suggestion) return false;
		this.props.UpdateSolicitorsDisplayedUsers([suggestion]);
		//user chose to see only a specific entry in the table - fabricate a get response to do so!
		let payload = {
			data: [suggestion],
			limit:0,
			offset:0,
			totalRecords:1
		};
		this.props.receiveGetSolicitors(payload);
		this.props.SolicitorDisplaySetting('value', suggestion.forename + ' ' + suggestion.surname)
	};

	render() {
	    const {onQuickSearch} = this.props;
		const value = this.props.User.solicitorUsersListSettings.value;
		const suggestions = this.props.User.solicitorUsersListSettings.suggestions;

		// Autosuggest will pass through all these props to the input.
		const inputProps = {
			placeholder: 'Search',
			value,
			onChange: this.onChange
		};

		return (
      <div className="row agentList-formFilters-wrapper">
          <div className="col-sm-12">
              <form className="form-horizontal">
                  <FormGroupSelectInput
                      Value={this.props.User.filterBySolicitor}
                      Label={`Filter by ${LEGAL_ADVICE_TEXT}`}
                      LeftWrapper="col-sm-2"
                      Options={[{key:'noFilter', value: `Select ${LEGAL_ADVICE_TEXT}`} ,...this.props.lawsysFirms.lawsysFirms.map((value) => {
                          return  {key: value.id, value: value.name}
                      })]}
                      HandleInputChange={(evt) => this.props.FilterByLawsysId(evt.target.value)}
                      CenterWrapper="col-sm-7 formGroupSelectInput-select-wrapper"
                      RightWrapper=""
                      SelectStyle={'form-control formGroupSelectInput-select'}
                  />
                  <div className="form-group">
                      <div className="col-sm-2">
                          <label className={'control-label.text-left formGroupSelectInput-label'}>
                              {"Search"}
                          </label>
                      </div>
                      <div className="col-sm-7"
                           onKeyPress={(evt) => evt.key === 'Enter' ?
                               (evt.preventDefault(),onQuickSearch() ): null}>
                          <Autosuggest
                              suggestions={suggestions}
                              onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                              onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                              getSuggestionValue={getSuggestionValue}
                              renderSuggestion={renderSuggestion}
                              inputProps={inputProps}
                              onSuggestionSelected={this.onAgentSuggestionSelected}
                              theme={{
                                  input: 'form-control agents-list-filter-elements  agents-list-filter-select',
                                  suggestionsContainer: 'agents-list-action-autoSuggest-suggestionContainer',
                                  container: 'agents-list-action-autoSuggest-container',
                                  suggestionsList: 'agents-list-action-autoSuggest-suggestionList',
                                  suggestion: 'agents-list-action-suggestion',
                                  suggestionHighlighted: 'agents-list-action-suggestion-highLighted'
                              }}
                          />
                          <div className="agents-list-filter-search"
                               onClick={onQuickSearch}>
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><title>Asset 6</title>
                                  <g id="Layer_2" data-name="Layer 2">
                                      <g id="info">
                                          <path
                                              d="M15.61,13.72l-3.48-3.48-.06,0a6.58,6.58,0,1,0-1.88,1.88l0,.06,3.48,3.48a1.34,1.34,0,0,0,1.89-1.89Zm-9-2.84a4.3,4.3,0,1,1,4.3-4.3A4.3,4.3,0,0,1,6.58,10.88Z"/>
                                      </g>
                                  </g>
                              </svg>
                          </div>
                      </div>
                  </div>

              </form>
          </div>
      </div>
		)
	}
}


export default AgentsListFilters;
